import { render, staticRenderFns } from "./StaffProductDetail.vue?vue&type=template&id=a85d5926&scoped=true"
import script from "./StaffProductDetail.vue?vue&type=script&lang=js"
export * from "./StaffProductDetail.vue?vue&type=script&lang=js"
import style0 from "./StaffProductDetail.vue?vue&type=style&index=0&id=a85d5926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d5926",
  null
  
)

export default component.exports